import { unionPageFragment } from 'petdna-lib-uicomponents/hygraph';

export const GET_OFFER_QUERY = ` 
    query PageLiOffer($where: PageLiOfferWhereUniqueInput!, $locale: [Locale!]!) {
      pageLiOffer(where: $where) {
        name
        offerPage  {
          ${unionPageFragment()}
        }
      }
    }
`;
